import { TranslateService } from '@ngx-translate/core/';
import { ConfirmationService } from 'primeng/components/common/api';
import { LoyaltyGiftReservationService } from 'app/services/loyalty/loyalty-gift-reservation.service';
import { BalanceModel } from './../../../models/balance.model';
import { LoyaltyBalanceService } from './../../../services/loyalty/loyalty-balance.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../services/user/auth.service';
import { StoreCommonService } from './../../../services/store/store-common.service';
import { CustomerInfoService } from '../../../services/customer/customerinfo.service';
import * as moment from 'moment';
import { PromotionCatalogService } from 'app/services/promotion/promotion-catalog.service';

@Component({
  selector: 'app-loyalty-balance',
  templateUrl: './loyalty-balance.component.html',
  styleUrls: ['./loyalty-balance.component.css']
})
export class LoyaltyBalanceComponent implements OnInit {
  customerId: number;
  balances: BalanceModel[] = [];
  customer: string;
  userId: string;
  divisionId: string;
  acmId:any;
  catalogVisible: boolean;
  errorEmailPhoneMsg: string;
  errorCompanyFiscalCodeMsg: string;
  errorCompanyAddressMsg: string;
  errorCatalogExpired: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private balanceService: LoyaltyBalanceService,
    private customerSrv: CustomerInfoService,
    private router: Router,
    private authService: AuthService,
    private storeCommonService: StoreCommonService,
    private giftService: LoyaltyGiftReservationService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    private promoService: PromotionCatalogService
  ) { }

  ngOnInit() {
    this.giftService.resetData();
    this.catalogVisible = false;
    this.giftService.search = false;
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.balanceService.getBalance(this.customerId).subscribe(res => {
      //this.balances = res;
      //this.customer = `${res[0].customer_code} - ${res[0].customer_name} ${res[0].customer_surname}`;
      //FIX KS-4106 per nascondere i saldi delle carte non attive
      if(res && res[0] && res.length>0){
        this.customerSrv.getCards(res[0].customer_host_id).subscribe(
          cards => {
            cards.forEach(resCard=>{
              if (!resCard.flagBlackList || resCard.flagBlackList === '0') {
                res.forEach(app=>{
                  if(app.card_no===resCard.cardNo){
                    this.balances.push(app);
                    this.acmId = app.acm_id;
                    this.customer = `${app.customer_code} - ${app.customer_name} ${app.customer_surname}`;
                    this.userId = this.authService.user.id.toString();
                    this.storeCommonService.getUserStoresAndSalesNetworks(this.userId).subscribe(res => {
                      if (res && res.length > 0) {
                        const divisionIdList: number[] = [];
                        res.forEach(division => {
                          if (division.division_sales_network_id) {
                            divisionIdList.push(division.division_sales_network_id);
                          }
                        });
                        this.divisionId = divisionIdList.join();
                        this.balances;
                        this.promoService.getCatalogVisible(this.divisionId, this.acmId ).subscribe(res => {
                        if(res  && res.length>0)
                            this.catalogVisible = true;
                        });
                      }
                    });
                    return
                  }
                });
              }
            });
          }
        );
      }
    });

    this.translateService.get([
      'reservations.errorEmailPhone',
      'reservations.errorCompanyFiscalCode',
      'reservations.errorCompanyAddress',
      'reservations.errorCatalogExpired'
    ]).subscribe(res => {
      this.errorEmailPhoneMsg = res['reservations.errorEmailPhone'];
      this.errorCompanyFiscalCodeMsg = res['reservations.errorCompanyFiscalCode'];
      this.errorCompanyAddressMsg = res['reservations.errorCompanyAddress'];
      this.errorCatalogExpired = res['reservations.errorCatalogExpired'];
    });
  }

  goBack() {
    window.history.back();
  }

  goToGiftReservation(balance) {
    if (!balance.telephone && !balance.email) {
      // Sempre necessario almeno uno tra mail e telefono in anagrafica
      this.confirmationService.confirm({
        message: this.errorEmailPhoneMsg,
        acceptLabel: 'Ok',
        rejectVisible: false
      });
      return;
    }
    if (balance.flg_company === 'S') {
      if (!balance.vat_fiscalcode) {
        // Se cliente di tipo azienda, sempre necessario codice fiscale
        this.confirmationService.confirm({
          message: this.errorCompanyFiscalCodeMsg,
          acceptLabel: 'Ok',
          rejectVisible: false
        });
        return;
      }
      if (!balance.address) {
        // Se cliente di tipo azienda, sempre necessario indirizzo in anagrafica
        this.confirmationService.confirm({
          message: this.errorCompanyAddressMsg,
          acceptLabel: 'Ok',
          rejectVisible: false
        });
        return;
      }
    }

    this.promoService.getActiveCatalog(balance.acm_id).subscribe(res => {
      if (res && res.length > 0) {
        this.getBalanceData(balance);
        this.router.navigate([`loyalty/gift-reservation/${this.customerId}/${this.divisionId}`]);
      }
      else {
        this.confirmationService.confirm({
          message: this.errorCatalogExpired,
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      }
    })
  }

  goToReservations(balance, reservationState: string) {
    this.getBalanceData(balance);
    this.router.navigate([`loyalty/reservations/${this.customerId}/${balance.card_id}/${balance.acm_id}/${reservationState}`]);
  }

  /**
   * Salva i dati del Balance selezionato in un Service, in modo da poterli recuperare nella prenotazione
   */
  getBalanceData(balance) {
    sessionStorage.setItem('acmCode', balance.acm_code);
    sessionStorage.setItem('acmId', balance.acm_id);
    sessionStorage.setItem('acmDescription', balance.acm_desc);
    sessionStorage.setItem('acm', `${balance.acm_code} - ${balance.acm_desc}`);
    sessionStorage.setItem('cardNo', balance.card_no);
    sessionStorage.setItem('customer', `${balance.customer_code} - ${balance.customer_name} ${balance.customer_surname}`);
    sessionStorage.setItem('cardId', balance.card_id);
    sessionStorage.setItem('customerHostId', balance.customer_host_id);
    sessionStorage.setItem('startingBalance', balance.value);
    sessionStorage.setItem('customerCode', balance.customer_code);
    sessionStorage.setItem('customerName', balance.customer_name);
    sessionStorage.setItem('customerSurname', balance.customer_surname);
    sessionStorage.setItem('customerFullName', `${balance.customer_name} ${balance.customer_surname}`);
    sessionStorage.setItem('email', balance.email);
    sessionStorage.setItem('telephone', balance.telephone);
  }

  acmExpired(dateEnd) {
    return (moment(new Date(dateEnd)).format('YYYY-MM-DD')) <  moment(new Date()).format('YYYY-MM-DD');
  }
}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-balance/loyalty-balance.component.ts